<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <!-- Title -->
    <h2 class="text-4xl md:text-5xl">{{ $t('Jouw Uitzend en bemiddelingsbureau in de zorg') }}</h2>

    <!-- Content -->
    <div class="mt-6 text-lg">
      <p
        class="mb-4"
      >{{ $t('Bij Zorgblik begrijpen we dat elke zorgvraag uniek is. Daarom hebben wij een team van gespecialiseerde zorgprofessionals die niet alleen over de juiste kennis en ervaring beschikken, maar ook een aanpak hanteren die draait om samenwerking en maatwerk.') }}</p>

      <p
        class="mb-4"
      >{{ $t('Onze werkwijze begint met een grondige analyse, samen met u als klant. Onze professionals nemen de tijd om uw situatie volledig te begrijpen. We bespreken niet alleen wat er nu speelt, maar analyseren ook de oorzaken en structurele uitdagingen. Dit doen we niet alleen, maar samen met u. We geloven dat uw input essentieel is om een volledig beeld te krijgen van de zorgbehoefte.') }}</p>

      <p
        class="mb-6"
      >{{ $t('Vervolgens kijken we gezamenlijk naar oplossingen die niet alleen direct helpen, maar ook toekomstbestendig zijn. Onze professionals werken met u aan een plan dat gericht is op de lange termijn.') }}</p>
    </div>

    <!-- Two-Column Layout -->
    <div class="grid md:grid-cols-2 gap-6">
      <div>
        <h3 class="text-xl font-semibold">{{ $t('Zorgblik') }}</h3>
        <p
          class="mt-2 text-lg"
        >{{ $t('Zorgblik is gespecialiseerd in de uitzending en bemiddeling van zorgprofessionals. Wij helpen zorginstellingen om de juiste professionals te vinden voor hun specifieke behoeften.') }}</p>
      </div>

      <div>
        <h3 class="text-xl font-semibold">{{ $t('Kwaliteit') }}</h3>
        <p
          class="mt-2 text-lg"
        >{{ $t('Wij selecteren zorgvuldig onze zorgprofessionals en zorgen voor een goede match tussen de professional en de zorginstelling.') }}</p>
      </div>
    </div>
  </div>
</template>